import * as React from 'react';

const { Component } = React;

import { createOrganization } from './OrganizationStore';
import { FormGroup, Input, Label, Button } from '../components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class CreateOrganization extends Component {
    state = {
        organization: {
            id: undefined,
            name: undefined
        },
        isLoaded: false
    };

    constructor(props) {
        super(props);
    }

    createOrganization = (event) => {
        event.preventDefault();
        if (event.target.name) {

            var data = {
                Name: event.target.name.value
            }

            createOrganization(data)
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            organization: result
                        });
                    },
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }

    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="space-y-6">
                {!this.state.isLoaded && (
                    <form onSubmit={this.createOrganization} className="space-y-4">
                        <FormGroup>
                            <Label htmlFor="orgName">Organization Name</Label>
                            <Input 
                                type="text" 
                                id="orgName"
                                name="name" 
                                placeholder="Enter organization name"
                                required
                            />
                        </FormGroup>
                        
                        <div className="flex justify-end pt-2">
                            <Button variant="primary" type="submit">
                                <FontAwesomeIcon icon={["fad", "plus-circle"]} className="mr-2" />
                                Create Organization
                            </Button>
                        </div>
                    </form>
                )}
                
                {this.state.isLoaded && (
                    <div className="space-y-4">
                        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                            <div className="flex items-center">
                                <FontAwesomeIcon icon={["fad", "check-circle"]} className="text-green-600 text-xl mr-3" />
                                <div>
                                    <h4 className="text-green-800 font-semibold">Organization Created Successfully!</h4>
                                    <p className="text-green-700 text-sm mt-1">Your new organization has been created and is ready to use.</p>
                                </div>
                            </div>
                        </div>
                        
                        <FormGroup>
                            <Label>Organization ID</Label>
                            <div className="px-3 py-2 bg-gray-50 rounded-md text-sm text-gray-700 font-mono border border-gray-200">
                                {this.state.organization.id}
                            </div>
                        </FormGroup>
                        
                        <FormGroup>
                            <Label>Organization Name</Label>
                            <div className="px-3 py-2 bg-gray-50 rounded-md text-sm text-gray-700 border border-gray-200">
                                {this.state.organization.name}
                            </div>
                        </FormGroup>
                        
                        <div className="flex justify-end pt-2">
                            <Button 
                                variant="secondary" 
                                onClick={() => window.location.reload()}
                            >
                                <FontAwesomeIcon icon={["fad", "plus"]} className="mr-2" />
                                Create Another
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}